import {DOCUMENT} from '@angular/common';
import {EnvironmentProviders, effect, inject, makeEnvironmentProviders, provideAppInitializer} from '@angular/core';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {MessageService} from 'primeng/api';
import {PrimeNG, providePrimeNG} from 'primeng/config';

import {LanguageStore} from '@core/i18n';

import {mydealsPreset} from './mydeals-preset';
import {PRIMENG_TRANSLATIONS} from './primeng-translations';
import {ThemeStore} from './theme-store';

function provideOverlayAnchorGutter(gutter: string): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const document = inject(DOCUMENT);
      const style = document.createElement('style');
      style.textContent = `:root{--p-anchor-gutter:${gutter}}`;
      document.head.appendChild(style);
    }),
  ]);
}

export function provideUi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: mydealsPreset,
        options: {
          darkModeSelector: false,
          cssLayer: {name: 'primeng', order: 'reset, primeng'},
        },
      },
      ripple: true,
    }),
    provideOverlayAnchorGutter('4px'),
    MessageService,
    provideAppInitializer(() => {
      inject(ThemeStore).initialize();
    }),
    provideAppInitializer(() => {
      const primeNg = inject(PrimeNG);
      const language = inject(LanguageStore);
      // Tenant language can change post-auth (see `LanguageStore`) — stays in sync via `current`.
      effect(() => primeNg.setTranslation(PRIMENG_TRANSLATIONS[language.current()]));
    }),
  ]);
}
